import { DataTableSkeleton, type DataTableSkeletonCell } from "../ui/DataTableSkeleton";

export function AgentsListSkeleton() {
  const headers = ["Agent", "Organization", "NPN", "Carriers", "Upline", "Claimed", "Contracts", "Registered", "Updated"];
  const cellVariants: DataTableSkeletonCell[] = [
    "multiline",
    "text",
    "text",
    "pills",
    "text",
    "text",
    "pills",
    "text",
    "text",
  ];

  return (
    <DataTableSkeleton
      headers={headers}
      cellVariants={cellVariants}
      loadingLabel="Loading agents"
    />
  );
}
